import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

const content = {
  en: {
    title: "Privacy",
    body: [
      "BibleVoice is a free digital ministry. We keep things simple and respectful of your privacy.",
      "We store an anonymous device identifier in your browser to count how many people the Word was shared with each day. We do not require accounts, and we do not sell your data.",
      "Conversations with the AI guide are processed to generate a response. Please avoid sharing sensitive personal information in the chat.",
    ],
  },
  fr: {
    title: "Confidentialit\u00e9",
    body: [
      "BibleVoice est un minist\u00e8re num\u00e9rique gratuit. Nous restons simples et respectueux de votre vie priv\u00e9e.",
      "Nous stockons un identifiant d\u2019appareil anonyme dans votre navigateur pour compter le nombre de personnes avec qui la Parole a \u00e9t\u00e9 partag\u00e9e chaque jour. Aucun compte n\u2019est requis et nous ne vendons pas vos donn\u00e9es.",
      "Les conversations avec le guide IA sont trait\u00e9es pour g\u00e9n\u00e9rer une r\u00e9ponse. \u00c9vitez de partager des informations personnelles sensibles.",
    ],
  },
  es: {
    title: "Privacidad",
    body: [
      "BibleVoice es un ministerio digital gratuito. Mantenemos las cosas simples y respetuosas con tu privacidad.",
      "Guardamos un identificador an\u00f3nimo de dispositivo en tu navegador para contar con cu\u00e1ntas personas se comparti\u00f3 la Palabra cada d\u00eda. No requerimos cuentas ni vendemos tus datos.",
      "Las conversaciones con el gu\u00eda IA se procesan para generar una respuesta. Evita compartir informaci\u00f3n personal sensible.",
    ],
  },
};

export default function Privacy() {
  const { lang } = useApp();
  const c = content[lang] || content.en;
  return (
    <div className="relative z-10 min-h-screen flex flex-col items-center px-4 py-12">
      <div className="w-full max-w-2xl">
        <Logo size="md" />
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm text-[var(--gold-deep)] hover:underline">
          <ArrowLeft size={16} /> {t(lang, "backHome")}
        </Link>
        <div className="glass-strong rounded-3xl p-8 md:p-10 mt-4 fade-up">
          <h1 className="font-display text-4xl font-semibold text-[var(--ink)] mb-6">{c.title}</h1>
          <div className="space-y-5 font-scripture text-lg leading-relaxed text-[var(--ink-soft)]">
            {c.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
